(() => {
  if (customElements.get('fp-ornament-size')) return;
  customElements.define('fp-ornament-size', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-orn-open]');
      this.picker = document.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
      if (!this.picker || !this.dialog.showModal) return;
      this.classList.add('is-ready');
      this.picker.classList.add('fp-orn-native-picker');
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-orn-open]')) {
          const selected = this.picker.querySelector('input:checked');
          this.querySelectorAll('.fp-orn-options input').forEach(input => { input.checked = input.dataset.option === selected?.value; });
          this.updatePending();
          this.dialog.showModal();
          document.documentElement.classList.add('fp-orn-dialog-open');
        }
        if (event.target.closest('[data-orn-close]') || event.target === this.dialog) this.dialog.close();
        if (event.target.closest('[data-orn-photo]')) {
          const field = document.querySelector('fiorpaw-personalisation[data-product-id="' + this.dataset.productId + '"] [data-fp-photo]');
          field?.scrollIntoView({ block: 'center', behavior: 'instant' });
          field?.focus({ preventScroll: true });
        }
        if (event.target.closest('[data-orn-use]')) {
          const input = this.querySelector('.fp-orn-options input:checked');
          const native = Array.from(this.picker.querySelectorAll('input[type="radio"]')).find(radio => radio.value === input?.dataset.option);
          if (!native || input.disabled) return;
          this.dialog.close();
          if (!native.checked) native.click();
        }
      }, opts);
      this.addEventListener('change', () => this.updatePending(), opts);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('fp-orn-dialog-open');
        this.opener.focus({ preventScroll: true });
      }, opts);
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const variant = event.detail.resource;
        if (variant) this.querySelector('[data-orn-current]').textContent = variant.option1 || variant.title;
        this.picker = document.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
        this.picker?.classList.add('fp-orn-native-picker');
      }, opts);
    }
    updatePending() {
      const selected = this.querySelector('.fp-orn-options input:checked');
      this.querySelector('[data-orn-pending]').textContent = selected?.dataset.title || '';
      this.querySelector('[data-orn-use]').disabled = !selected || selected.disabled;
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.documentElement.classList.remove('fp-orn-dialog-open');
    }
  });
})();


